import './web.config';
// polyfill import must be up the top
import 'core-js';
import 'core-js/features/url-search-params';
import 'core-js/stable/array/includes';
import 'regenerator-runtime/runtime';

import './scss/app.scss';

import 'jquery/dist/jquery.slim.min.js';

import '../../Common/js/util/attributeHelper';
import '../../Common/js/util/environment';
import after_polyfills_load from '../../Common/js/util/load-polyfills';
import '../../Common/js/util/focus';
import '../../Common/js/util/appLocationCookies';
import setWindowCookie from '../../Common/js/util/cookie';

//bootstrap
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/collapse';

// import './modules/carousel/carousel';
import { carouselResponsive } from './modules/highlights-carousel/carousel';
import './modules/dropdowns/dropdowns-filters';
import './modules/pagination/pagination-filters';
import './modules/tabbed-content/tabbed-content';
// import './modules/video/video';
// import './modules/year-select/year-select--filter';
// import './modules/header/header';
import './modules/forms/forms';
import './modules/search/search';
// import './modules/rsl-card/rsl-card';

//Note that polyfills will not start loading until this is run
after_polyfills_load(() => {
  // Run code in here that depends on the polyfills loading first
  const contentContainers = $('.container.content');
  if (contentContainers.length) {
    contentContainers[0].id = 'scroll-down-anchor';
  }
  carouselResponsive();
});

setWindowCookie();